<template>
    <el-collapse-item :name="name" :class="{selected: isSelected}">
        <template v-slot:title>
            <div class="pl-1 py-2 w-100" @click="select">
                <div>
                    <span class="el-style attribute-name">Sender:</span> {{ sender }}
                </div>
                <div>
                    <span class="el-style attribute-name">Recipient:</span> {{ recipient }}
                </div>
            </div>
        </template>
        <div class="pl-1">
            <div class="el-style attribute-name">Message:</div>
            <div>{{ message }}</div>
        </div>
    </el-collapse-item>
</template>

<script>
  export default {
    props: {
      item: Object,
      isSelected: Boolean,
    },

    computed: {
      /**
       * @return {object|null}
       */
      model() {
        return _.get(this, 'item.model', null);
      },

      name() {
        return _.get(this, 'model.id', '');
      },

      /**
       * @return {string}
       */
      sender() {
        return _.get(this, 'model.outgoing_number.title', '');
      },

      /**
       * @return {string}
       */
      recipient() {
        return _.get(this, 'model.contact_list.name', '');
      },

      /**
       * @return {string}
       */
      message() {
        return _.get(this, 'model.body', '');
      },
    },

    methods: {
      /**
       * @emits select
       */
      select() {
        this.$emit('select', this.item);
      }
    },
  }
</script>
